/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type SetOrganizedByBodyOrganizedBy = (typeof SetOrganizedByBodyOrganizedBy)[keyof typeof SetOrganizedByBodyOrganizedBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetOrganizedByBodyOrganizedBy = {
  client: "client",
  agent: "agent",
} as const;
